import React from "react";
import logopacs from "./pacslogo.jpg";
import "./Header.css";

function Header() {
  return (
    <div className="header-fix-at-top kk">
      <div className="logo-container hrif">
        <img
          src="https://www.principleacs.net/FTA_WEB_PORTAL_V2/addSite/public/pacslogo.jpg"
          alt="Logo"
          className="logo logo-container1"
        />
        <h4>
          {/* <a
            style={{ color: "white" }}
            href="https://pacsbackendcalims.netlify.app/"
            target="_blank"
            // className="link-underline-opacity-100-hover "
          >
            bulk reports
          </a> */}
        </h4>
        {/* <h1 className="header-top">Principle Acs</h1> */}
      </div>
    </div>
  );
}

export default Header;
